import styled from 'styled-components';

import RadioButton from 'components/RadioButton';
import Icon from 'components/Icon';

import {commonPalette} from 'styles/palette';
import {darken} from 'utils/color-utils';

export const ContentWrapper = styled.div`
  width: 100%;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0;
  margin: 0 0 20px 0;
`;

export const StyledInfo = styled.div`
  margin-bottom: 10px;
  font-size: 14px;
  line-height: 20px;
  color: ${commonPalette.txBlack};
`;

export const AcceptAllCookiesButton = styled.a`
  color: ${commonPalette.white};
  background: ${({disabled}) => (disabled ? commonPalette.lightGreen : commonPalette.sgGreen)};
  padding: 10px 20px;
  text-decoration: none;
  border-radius: 4px;
  text-align: center;
  min-width: 185px;
  display: inline-block;
  position: relative;
  font-size: 14px;

  &:hover {
    color: ${commonPalette.white};
    background: ${({disabled}) => (disabled ? commonPalette.lightGreen : darken(commonPalette.sgGreen, 0.15))};
  }

  &:link {
    text-decoration: none;
  }
`;

export const StyledListTitle = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: ${commonPalette.txBlack};
  font-weight: bold;
`;

export const StyledItem = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: ${commonPalette.txBlack};
`;

export const StyledLink = styled.a`
  color: inherit;
  font-weigth: 600;
  text-decoration: underline;
  text-underline-offset: 3px;

  &:hover {
    color: ${commonPalette.txBlack};
    text-decoration: underline;
    text-underline-offset: 3px;
  }
`;

export const StyledRadioButton = styled(RadioButton).attrs({
  height: 20
})`
  color: ${commonPalette.txBlack};
  margin: 0 14px;
`;

export const WrapperOptions = styled.div`
  display: flex;
`;

export const StyledHeader = styled.div`
  font-size: ${({isMobile}) => (isMobile ? '20px' : '26px')};
  color: ${commonPalette.txBlack};
`;

export const SavePreferencesButton = styled.a`
  color: ${commonPalette.sgGreen};
  background: ${({disabled}) => (disabled ? commonPalette.disabledText : commonPalette.white)};
  padding: 10px 20px;
  text-decoration: none;
  border-radius: 4px;
  text-align: center;
  box-shaddow: rgb(0 0 0 / 12%) 0px 0px 1px, rgb(0 0 0 / 24%) 0px 1px 1px;
  border: 1px solid ${commonPalette.borderGrey};
  min-width: 185px;
  display: inline-block;
  position: relative;
  font-size: 14px;

  &:hover {
    color: ${commonPalette.sgGreen};
    background: ${({disabled}) => (disabled ? commonPalette.disabledText : commonPalette.hoverGrey)};
    box-shaddow: rgb(0 0 0 / 12%) 0px 0px 1px, rgb(0 0 0 / 24%) 0px 1px 1px;
    border: 1px solid ${commonPalette.borderGrey};
  }

  &:link {
    text-decoration: none;
  }
`;

export const Line = styled.div`
  border-bottom: 1px solid ${commonPalette.borderGrey};
  margin: 30px 0;
`;

export const StyledListItem = styled.li`
  font-size: 14px;
  line-height: 20px;
  color: ${commonPalette.txBlack};
  margin: 0 0 2px 8px;
`;

export const EmptySection = styled.div`
  margin-bottom: 15px;
`;

export const CloseButton = styled(Icon).attrs({
  name: 'close'
})`
  height: 14px;
  color: ${commonPalette.txBlack};
  margin-top: 10px;
`;

export const ListWrapper = styled.div`
  margin-top: 16px;
`;

export const StyledSpan = styled.span`
  margin-left: -6px;
`;

export const ButtonWrapper = styled.div`
  margin: 20px 0;
`;
